/**
 * 공통 에러 코드 상수 (SSOT)
 * @description
 * GraphQL 응답 타입에서 사용하는 에러 코드를 중앙 관리합니다.
 * DRY 원칙: 모든 에러 코드는 이 파일에서 정의하고 import하여 사용합니다.
 */

/**
 * 공통 에러 코드
 * @description 인증, 권한, 리소스 관련 공통 에러
 */
export const COMMON_ERROR_CODES = {
  /** 인증 필요 */
  UNAUTHORIZED: "UNAUTHORIZED",
  /** 권한 없음 (회사 격리 위반) */
  FORBIDDEN: "FORBIDDEN",
  /** 리소스 없음 */
  NOT_FOUND: "NOT_FOUND",
  /** 버전 충돌 (다른 사용자 수정) */
  VERSION_CONFLICT: "VERSION_CONFLICT",
  /** 입력값 검증 실패 */
  VALIDATION_FAILED: "VALIDATION_FAILED",
} as const;

export type CommonErrorCode = (typeof COMMON_ERROR_CODES)[keyof typeof COMMON_ERROR_CODES];

/**
 * 설비 관련 에러 코드
 * @description 설비 문서 조회/수정 시 발생하는 에러
 */
export const MACHINE_ERROR_CODES = {
  ...COMMON_ERROR_CODES,
  /** 유효하지 않은 설비 키 */
  INVALID_MACHINE_KEY: "INVALID_MACHINE_KEY",
  /** 유효하지 않은 설비 문서 ID */
  INVALID_MACHINE_ID: "INVALID_MACHINE_ID",
} as const;

export type MachineErrorCode = (typeof MACHINE_ERROR_CODES)[keyof typeof MACHINE_ERROR_CODES];

/**
 * 설비 문서 항목 수정 에러 코드
 * @description updateMachineDocumentItems mutation에서 사용
 */
export const ITEMS_ERROR_CODES = {
  ...MACHINE_ERROR_CODES,
  /** arrayFilters 20개 초과 */
  ARRAY_FILTERS_EXCEEDED: "ARRAY_FILTERS_EXCEEDED",
} as const;

export type ItemsErrorCode = (typeof ITEMS_ERROR_CODES)[keyof typeof ITEMS_ERROR_CODES];

/**
 * 설비 정보 수정 에러 코드
 * @description updateMachineInfo mutation에서 사용
 */
export const MACHINE_INFO_ERROR_CODES = {
  ...MACHINE_ERROR_CODES,
  /** 유효하지 않은 날짜 범위 */
  INVALID_DATE_RANGE: "INVALID_DATE_RANGE",
} as const;

export type MachineInfoErrorCode =
  (typeof MACHINE_INFO_ERROR_CODES)[keyof typeof MACHINE_INFO_ERROR_CODES];

/**
 * 사진대지 수정 에러 코드
 * @description updateMachineDocumentPictures mutation에서 사용
 */
export const PICTURES_ERROR_CODES = {
  ...MACHINE_ERROR_CODES,
} as const;

export type PicturesErrorCode = (typeof PICTURES_ERROR_CODES)[keyof typeof PICTURES_ERROR_CODES];
